<template>
	<!-- eslint-disable vue/no-v-html -->

	<v-sheet color="primary" :height="300" width="100%">
		<v-container fluid pa-0>
			<v-row
				align="center"
				justify="center"
				class="white--text"
				:style="{ height: height + 'px' }"
			>
				<v-col v-if="step.image" cols="12" sm="6" class="pa-0" order-sm="2">
					<v-img
						:height="height"
						width="100%"
						contain
						:src="step.image"
						:v-if="step.image"
					/>
				</v-col>
				<v-col
					cols="12"
					:sm="step.image ? 4 : 12"
					:offset-sm="step.image ? 1 : 0"
					order-sm="1"
					:class="textSize"
					align="center"
					justify="center"
					v-html="step.text"
				/>
			</v-row>
		</v-container>
	</v-sheet>
</template>

<script>
export default {
	props: {
		step: Object,
	},
	computed: {
		textSize() {
			return this.$vuetify.breakpoint.xsOnly ? "body-3" : "headline";
		},
		height() {
			return this.$vuetify.breakpoint.xsOnly ? 150 : 300;
		},
	},
};
</script>

<style></style>
